module.exports = __webpack_public_path__ + "static/media/frete.74138235.svg";